export default __webpack_public_path__ + "static/media/confettiItems.02ceef7a.svg";